import React, { useEffect, useRef, useState } from "react";
import BackArrow from "../../resources/icons/chevron-left.svg";
import EntityConstants from "../../configs/EntityConstants";
import { useParams, useLocation } from "react-router-dom";
import { GET } from "../../service/CRUDService";
import DownloadFile from "../../service/DownloadFile";
import toast from "react-hot-toast";
import Download from "../../resources/icons/download-01.svg";
import DownloadDisabled from "../../resources/icons/download-01-disabled.svg";
import BackArrowSquare from "../../resources/icons/arrow-square-up-right.svg";
import BackArrowSquareDisabled from "../../resources/icons/arrow-square-up-right-disabled.svg";
import CredentialPreviewModal from "../../common/CredentialPreviewModal/CredentialPreviewModal";
import useInterceptedNavigate from "../../hooks/useInterceptedNavigate";

const BATCH_TRANSACTION_POLLING_TIME_INTERVAL = 5000;
const BatchTransaction = () => {
  const navigate = useInterceptedNavigate();
  const { transaction_id, transaction_name } = useParams();
  const [isSingleIssuance, setIsSingleIssuance] = useState();
  const [respContentList, setRespContentList] = useState([]);

  const location = useLocation();
  const { transaction_status } = location.state || {};

  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit, setlimit] = useState(10);

  const [isOpen, setIsOpen] = useState(false);
  const [currentCredentialId, setCurrentCredentialId] = useState(null);
  // const [printScreen, setPrintScreen] = useState(false); // !This is for print

  const [detailsList, setDetailsList] = useState([]);

  const [isLoadingcontentList, setIsLoadingcontentList] = useState(true);
  const customElementRef = useRef(null);
  const [showModal, setShowModal] = useState("");
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [isStatus, setIsStatus] = useState(null);

  const toggleNotificationModal = (val) => {
    setShowModal(val);
  };

  useEffect(() => {
    transaction_id && GET_ALL_TRANSACTIONS_LIST(limit, offset);
  }, [transaction_id]);

  const SEARCH = (e) => {
    e.preventDefault();
    console.log(e);
  };

  const GET_ALL_TRANSACTIONS_LIST = async (limit, offset) => {
    try {
      const response = await GET(
        `${EntityConstants.GET_USER_BULK_TRANSACTION_DETAILS}/${transaction_id}?offset=${offset}&limit=${limit}&statuses=Revoked,Issued,Sent`
      );

      if (response.ok) {
        const data = await response.json();
        count !== data.count && setCount(data.count);
        setOffset(offset);
        setDetailsList([...data.results]);
        setPrevious(data.previous);
        setNext(data.next);
        setIsStatus(data.status);
        data.results.length !== 0 && setIsLoadingcontentList(false);
      } else {
        console.log(response?.error);
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Failed to fetch bulk data:", error);
    }
  };

  const CtaList = [
    // {
    //   name: "Notify",
    //   icon: <RiSendPlaneFill size={20} />,
    //   onClick:() => toggleNotificationModal(detailsList?.credential_id),
    // },
    {
      name: "BackArrowSquare",
      idSuffix: "preview",
      iconActive: <img src={BackArrowSquare} alt="" srcset="" />,
      iconDisabled: <img src={BackArrowSquareDisabled} alt="" srcset="" />,
      onClick: (credential_id) => {
        openCloseModal(credential_id);
      },
    },
    // { // !This is for print
    //   name: "Print PDF",
    //   icon: <img src={Printer} alt="" srcset="" />,
    //   onClick: (credential_id, svg_url) => {
    //     openPrintScreen(svg_url);
    //   },
    // },
    {
      name: "Download",
      idSuffix: "download",
      iconActive: <img src={Download} alt="" srcset="" />,
      iconDisabled: <img src={DownloadDisabled} alt="" srcset="" />,
      onClick: (credential_id) =>
        DownloadFile(EntityConstants.DOWNLOAD_SVG_AS_PNG, credential_id),
    },
    // {
    //   name: "...",
    //   icon: <img src={Dots} alt="" srcset="" />,
    //   onClick: () => {},
    // },
  ];

  const handleDownloadZip = (event) => {
    event.stopPropagation();
    console.log(
      "The EntityConstants.DOWNLOAD_SVG_AS_ZIP, transaction_id : ",
      EntityConstants.DOWNLOAD_SVG_AS_ZIP,
      " ",
      transaction_id
    );
    DownloadFile(EntityConstants.DOWNLOAD_SVG_AS_ZIP, transaction_id);
  };

  const openCloseModal = (credential_id) => {
    if (isOpen && currentCredentialId === credential_id) {
      setIsOpen(false);
      setCurrentCredentialId(null);
    } else {
      setIsOpen(true);
      setCurrentCredentialId(credential_id);
    }
  };
  // const openPrintScreen = (url) => { // !This is for print screen
  //   setPrintScreen(url);
  //   setTimeout(() => {
  //     setPrintScreen(null);
  //   }, 1000);
  // };
  useEffect(() => {
    let pollingInterval;
    if (
      detailsList.some((credential) => !credential.status) ||
      detailsList.length < 1 ||
      isStatus === "In Progress"
    ) {
      pollingInterval = setInterval(() => {
        GET_ALL_TRANSACTIONS_LIST(limit, offset);
      }, BATCH_TRANSACTION_POLLING_TIME_INTERVAL); // 5-second interval
    }
    return () => {
      clearInterval(pollingInterval); // Clear interval on cleanup
    };
  }, [detailsList, offset]);
  return (
    <div className="mt-20 bg-cfSecondary min-h-screen">
      <div className="flex w-full justify-between py-[2.625rem] px-[0.75rem]">
        <div className=" flex items-center text-[#101828] font-bold ">
          <img
            id="batch-transaction-back-link"
            src={BackArrow}
            className="cursor-pointer"
            alt=""
            onClick={() => navigate(-1)}
          />
          <p>{transaction_name}</p>
        </div>

        {count > 1 && (
          <div
            id="batch-transaction-download-all-button"
            // onClick={() => handleDownloadClick(detailsList.credential_id)}
            onClick={(e) => handleDownloadZip(e)}
            className="cursor-pointer py-[0.875rem] px-[2.063rem] font-semibold rounded-lg bg-cfPrimary text-cfSecondary"
          >
            <p>Download all certificates</p>
          </div>
        )}
      </div>
      <div class="overflow-x-auto">
        {detailsList.length === 0 && (
          <table class="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead class="text-xs text-[#344054] font-bold bg-[#E0EAFF]">
              <tr>
                <th scope="col" class="px-6 py-3">
                  Name
                </th>
                <th scope="col" class="px-6 py-3">
                  Email ID
                </th>
                <th scope="col" class="px-6 py-3">
                  Phone number
                </th>
                <th scope="col" class="px-6 py-3">
                  Whatsapp number
                </th>
                <th scope="col" class="px-6 py-3">
                  Status
                </th>
                <th scope="col" class="px-6 py-3">
                  Preview and Download
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b hover:bg-[#F9FAFB]">
                <th
                  scope="row"
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap animate-pulse"
                >
                  Loading . . .
                </th>
                <td class="px-6 py-4 animate-pulse">Loading . . .</td>
                <td class="px-6 py-4 animate-pulse">Loading . . .</td>
                <td class="px-6 py-4 animate-pulse">Loading . . .</td>
                <td class=" py-4">
                  <p
                    className={`w-fit font-semibold text-[#EBF8E7] px-[1.125rem] ml-2.5 py-[0.125rem] text-cfSecondary rounded-full bg-gray-300 animate-pulse`}
                  >
                    Loading . . .
                  </p>
                </td>
                <td class="px-14 py-4">
                  <div className="flex items-center gap-[2.125rem]">
                    {CtaList.map(
                      ({ idSuffix, iconDisabled }, index) => (
                        <div
                          id={`batch-transaction-loading-${idSuffix}-button`}
                          className="flex items-center gap-[0.5rem] w-6 cursor-not-allowed"
                          key={index}
                        >
                          {iconDisabled}
                        </div>
                      )
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {detailsList.length > 0 && (
          <table class="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead class="text-xs text-[#344054] font-bold bg-[#E0EAFF]">
              <tr>
                <th scope="col" class="px-6 py-3">
                  Name
                </th>
                <th scope="col" class="px-6 py-3">
                  Email ID
                </th>
                <th scope="col" class="px-6 py-3">
                  Phone number
                </th>
                <th scope="col" class="px-6 py-3">
                  Whatsapp number
                </th>
                <th scope="col" class="px-6 py-3">
                  Status
                </th>
                <th scope="col" class="px-6 py-3">
                  Preview and Download
                </th>
              </tr>
            </thead>
            <tbody>
              {detailsList.map(
                ({
                  credential_id,
                  approved_by,
                  issuer_name,
                  email_id,
                  mobile_number,
                  recipient_name,
                  status,
                  updated_at,
                  svg_url,
                  thumbnail_url,
                  whatsapp_number,
                }) => (
                  <tr class="border-b hover:bg-[#F9FAFB]" key={credential_id}>
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                    >
                      {recipient_name}
                    </th>
                    <td class="px-6 py-4">{email_id}</td>
                    <td class="px-6 py-4">{mobile_number}</td>
                    <td class="px-6 py-4">{whatsapp_number}</td>
                    <td class=" py-4">
                      <p
                        className={`w-fit font-semibold text-[#EBF8E7] px-[1.125rem] ml-2.5 py-[0.125rem] text-cfSecondary rounded-full ${
                          status === "Sent"
                            ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
                            : status === "Under Review"
                            ? "bg-cfIssuedCredentialTemplateCardStatusUnderReviewBG"
                            : status === "Revoked"
                            ? "bg-cfIssuedCredentialTemplateCardStatusRevokedBG"
                            : !status && " bg-gray-300 "
                        }`}
                      >
                        {status ? status : "Unavailable"}
                      </p>
                    </td>
                    <td class="px-14 py-4">
                      <div className="flex items-center gap-[2.125rem]">
                        {CtaList.map(
                          ({ idSuffix, iconActive, onClick }, index) => (
                            <div
                              id={`transaction-row-${credential_id}-${idSuffix}-button`}
                              className="flex items-center gap-[0.5rem] cursor-pointer w-6"
                              key={index}
                              onClick={() => onClick(credential_id)}
                              // onClick={() => onClick(credential_id, svg_url)} // !This is for print
                            >
                              {iconActive}
                            </div>
                          )
                        )}
                      </div>
                    </td>
                    {isOpen && currentCredentialId === credential_id && (
                      <CredentialPreviewModal
                        credential_id={credential_id}
                        approved_by={approved_by}
                        issuer_name={issuer_name}
                        email_id={email_id}
                        mobile_number={mobile_number}
                        recipient_name={recipient_name}
                        status={status}
                        updated_at={updated_at}
                        svg_url={svg_url}
                        thumbnail_url={thumbnail_url}
                        whatsapp_number={whatsapp_number}
                        openCloseModal={openCloseModal}
                        isOpen={isOpen}
                      />
                    )}
                  </tr>
                )
              )}
            </tbody>
          </table>
        )}
      </div>
      <div className="flex items-center justify-between mt-6 px-8 w-full">
        <button
          id="batch-transaction-pagination-previous-button"
          onClick={() => GET_ALL_TRANSACTIONS_LIST(limit, offset - limit)}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={previous === null}
        >
          <span className="flex items-center justify-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>

            <span>previous</span>
          </span>
        </button>

        <button
          id="batch-transaction-pagination-next-button"
          onClick={() => GET_ALL_TRANSACTIONS_LIST(limit, offset + limit)}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={next === null}
        >
          <span className="flex items-center justify-center gap-2">
            <span>Next</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </span>
        </button>
      </div>
      {/* {printScreen && <PrintIssuedCertificate svg_url={printScreen} />} */}
    </div>
  );
};

export default BatchTransaction;
